<template>
  <div>

    <div class="card" v-if="editLocked">
      <h3>新增物品</h3>
      <div class="grid">
        <input v-model.trim="form.name" placeholder="name" />
        <input v-model.number="form.purchase_price" type="number" min="0" step="0.01" placeholder="purchase_price" />
        <input v-model.trim="form.purchase_date" placeholder="purchase_date (YYYY-MM-DD 可空)" />
        <input v-model.trim="form.purchase_month" placeholder="purchase_month (YYYY-MM 可空)" />
      </div>
      <button @click="create" :disabled="loading || !form.name || form.purchase_price == null">创建</button>
      <p v-if="error" class="error">{{ error }}</p>
    </div>

    <div class="card">
      <div class="row">
        <h3>列表</h3>
        <button @click="load" :disabled="loading">{{ loading ? "加载中..." : "刷新" }}</button>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>name</th>
            <th>price</th>
            <th>bought date</th>
            <th>status</th>
            <th>cost/day</th>
            <th v-if="editLocked">actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="it in items" :key="it.id">
            <td @click="promptItemName(it.id)">
              {{ it.name }}</td>
            <td @click="promptPurchasePrice(it.id)">
              {{ it.purchase_price }}
            </td>
            <td @click="promptPurchaseDate(it.id)">
              {{ it.purchase_date }}
            </td>
            <!-- <td>{{ it.status }} at {{ 1 }}</td> -->
            <td>{{ statusText(it) }}</td>
            <!-- <td>
              <span v-if="it.cost_per_day == null">缺少购买日期</span>
              <span v-else>{{ Number(it.cost_per_day).toFixed(2) }}</span>
            </td> -->
            <td>
              <span v-if="costPerDay(it) == null">缺少购买日期</span>
              <span v-else>{{ costPerDay(it).toFixed(2) }}</span>
            </td>
            <td class="actions" v-if="editLocked">
              <button @click="setStatus(it.id, 'active')">active</button>
              <button @click="promptResold(it.id)">resold</button>
              <button @click="setStatus(it.id, 'broken')">broken</button>
              <button @click="setStatus(it.id, 'archived')">archived</button>
            </td>
          </tr>
          <tr v-if="!items.length">
            <td colspan="5" style="color:#666;">暂无数据</td>
          </tr>
        </tbody>
      </table>

      <p v-if="error2" class="error">{{ error2 }}</p>
    </div>
  </div>
</template>

<script>
import { api, clearToken } from "@/api/client";

export default {
  name: "Items",
  props: {
    editLocked: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      error: "",
      error2: "",
      form: {
        name: "",
        purchase_price: null,
        purchase_date: "",
        purchase_month: "",
      },
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    statusText(it) {
      const status = it.status || "active";

      // 优先展示“有意义的日期”
      const resaleDate = it.resale_date;
      const changedAt = it.status_changed_at;

      // 用你已有的格式化函数（如果你已经写了 formatDateTime）
      const fmt = (v) => {
        if (!v) return "";
        const d = new Date(v);
        if (Number.isNaN(d.getTime())) return String(v);
        const pad = (n) => String(n).padStart(2, "0");
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
      };

      if (status === "resold") {
        // 出售以 resale_date 为准
        if (resaleDate) return `出售于 ${fmt(resaleDate)}`;
        // 兜底：没填 resale_date 的话就用状态变更时间
        if (changedAt) return `出售（记录于 ${fmt(changedAt)}）`;
        return "已出售";
      }

      if (status === "broken") {
        if (changedAt) return `于 ${fmt(changedAt)} 完全报废`;
        return "已报废";
      }

      if (status === "archived") {
        if (changedAt) return `于 ${fmt(changedAt)} 归档`;
        return "已归档";
      }

      // active
      return "使用中";
    },
    costPerDay(it) {
      // 1️⃣ 获取起始日期
      let start = null;

      if (it.purchase_date) {
        start = new Date(it.purchase_date);
      } else if (it.purchase_month) {
        start = new Date(it.purchase_month + "-01");
      } else {
        return null;
      }

      if (Number.isNaN(start.getTime())) return null;

      // 2️⃣ 结束日期逻辑（与你后端规则一致）
      let end = new Date();

      if (it.status === "resold" && it.resale_date) {
        end = new Date(it.resale_date);
      }

      if (it.status === "broken" && it.status_changed_at) {
        end = new Date(it.status_changed_at);
      }

      if (Number.isNaN(end.getTime())) return null;

      // 3️⃣ 计算天数（包含当天）
      const msPerDay = 1000 * 60 * 60 * 24;
      const diff = Math.floor((end - start) / msPerDay) + 1;

      const days = Math.max(diff, 1);

      // 4️⃣ 净成本
      const purchase = Number(it.purchase_price || 0);
      const resale = Number(it.resale_price || 0);
      const net = purchase - resale;

      return net / days;
    },
    async load() {
      this.error2 = "";
      this.loading = true;
      try {
        const data = await api.listItems();
        // 你的后端如果返回 { items: [...] } 就用 data.items
        this.items = Array.isArray(data) ? data : (data.items || []);
      } catch (e) {
        this.handleErr(e, "error2");
      } finally {
        this.loading = false;
      }
    },
    async create() {
      this.error = "";
      this.loading = true;
      try {
        // purchase_date 与 purchase_month 建议互斥：这里做个简单处理
        const payload = {
          name: this.form.name,
          purchase_price: this.form.purchase_price,
          purchase_date: this.form.purchase_date || null,
          purchase_month: this.form.purchase_date ? null : (this.form.purchase_month || null),
        };
        await api.createItem(payload);
        this.form.name = "";
        this.form.purchase_price = null;
        this.form.purchase_date = "";
        this.form.purchase_month = "";
        await this.load();
      } catch (e) {
        this.handleErr(e, "error");
      } finally {
        this.loading = false;
      }
    },
    async setStatus(id, status) {
      this.error2 = "";
      this.loading = true;
      try {
        await api.setItemStatus(id, { status });
        await this.load();
      } catch (e) {
        this.handleErr(e, "error2");
      } finally {
        this.loading = false;
      }
    },
    async updateItem(id, payload) {
      this.error2 = "";
      this.loading = true;
      try {
        await api.updateItem(id, payload );
        await this.load();
      } catch (e) {
        this.handleErr(e, "error2");
      } finally {
        this.loading = false;
      }
    },
    async promptItemName(id){
      const name = prompt("name", "");
      if (!name) return;
      // console.log(price)
      // return
      const payload = {name : name };
      await this.updateItem(id, payload)
    },
    async promptPurchasePrice(id){
      const price = prompt("price (float)", "89.99");
      if (!price) return;
      // console.log(price)
      // return
      const payload = {purchase_price : price };
      if (price){
        payload.purchase_price = Number(price);
        
      }
      await this.updateItem(id, payload)
    },
    async promptPurchaseDate(id){
      const purchase_date = prompt("purchase_date (YYYY-MM-DD)", "2026-02-24");
      if (!purchase_date) return;

      const payload = { purchase_date };

      await this.updateItem(id, payload)
    },
    async promptResold(id,status) {
      const resale_date = prompt("resale_date (YYYY-MM-DD)", "2026-02-24");
      if (!resale_date) return;

      const resale_price_str = prompt("resale_price (可空)", "");

      const payload = { status: "resold", resale_date };
      if (resale_price_str) payload.resale_price = Number(resale_price_str);

      await this.updateItem(id, payload)

      // await this.setStatus(id, "resold"); // 先走 setStatus？不行，需要带参数
    },
    handleErr(e, field) {
      const msg = e && e.message ? e.message : "请求失败";
      this[field] = msg;

      // 401 直接踢回登录
      if (e && e.status === 401) {
        clearToken();
        this.$router.replace("/login");
      }
    },
  },
};
</script>

<style scoped>
.card { background:#fff; border:1px solid #eee; border-radius:12px; padding:14px; margin-top:12px; }
.grid { display:grid; grid-template-columns: 1fr 1fr; gap:10px; margin:10px 0; }
input { padding:8px 10px; border:1px solid #ddd; border-radius:8px; }
button { padding:8px 10px; border:1px solid #ddd; background:#fff; border-radius:8px; cursor:pointer; }
.row { display:flex; align-items:center; justify-content:space-between; }
.table { width:100%; border-collapse: collapse; margin-top: 10px; }
th, td { border-top: 1px solid #eee; padding: 8px; text-align:left; font-size: 14px; }
.actions { display:flex; gap:6px; flex-wrap: wrap; }
.error { margin-top: 8px; color:#b42318; font-size: 13px; }
</style>